import { GlobalContext, GlobalMutations } from "./types";
import { Layers } from "@/models/map/layers";

export const addLoading = (
  context: GlobalContext,
  value: boolean
) => {
  context.commit(GlobalMutations.SetLoading, value);
};

export const addLoggedIn = (
  context: GlobalContext,
  value: boolean
) => {
  context.commit(GlobalMutations.SetLoggedIn, value);
};

export const addActiveView = (
  context: GlobalContext,
  value: Layers
) => {
  context.commit(GlobalMutations.SetActiveView, value);
};

